module.exports = __webpack_public_path__ + "static/media/drought-after.f9a40e6c.png";